import axios from "src/utils/axios";

export const getMaintenanceStatus = async ({ signal }) => {
  const { data } = await axios.get('/auth/maintenance', { signal });
  return data;
};
export const ordersSchool = async ({ queryKey, signal }) => {
  const [_, schoolID, years, packageID, status, fromDate, toDate, shippingType, courierCompany] = queryKey;

  const params = new URLSearchParams();

  if (packageID) params.append("packageID", packageID);
  if (status) params.append("status", status);
  if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);
  if (shippingType) params.append("shippingType", shippingType);
  if (courierCompany) params.append("courierCompanyID", courierCompany); 

  years.forEach((year) => params.append("years", year)); 

  const url = `orders/vendor/school/${schoolID}?${params.toString()}`;

  const { data } = await axios.get(url, { signal });
  return data.data;
};

export const VendorOrdersList = async ({ queryKey, signal }) => {
  const req = {
    riderID: queryKey[2] === "" ? undefined : +queryKey[2],
    schoolID: queryKey[3] === "" ? undefined : +queryKey[3],
    packageID: queryKey[4] === "" ? undefined : +queryKey[4],
    status: queryKey[5] === "" ? undefined : queryKey[5],
    fromDate: queryKey[6] ?? undefined,
    toDate: queryKey[7] ?? undefined,
    shippingType: queryKey[8] === "" ? undefined : +queryKey[8],
    year:
    queryKey[9] && queryKey[9].length
      ? queryKey[9].join(",")
      : new Date().getFullYear().toString(),
  };
  const { data } = await axios.post("orders/vendor/filterList/vendor", req);
  return data.data;
};
export const ordersSingleOrder = async ({ queryKey, signal }) => {
  const { data } = await axios("orders/vendor/singleOrder/" + queryKey[1]);
  return data.data;
};
export const masterGetDataa = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/vendor/getData",
    { tableName: queryKey[1], page: +queryKey[2] + 1, limit: queryKey[3] },
    { signal }
  );
  return data?.data[0] || [];
};
export const masterGetData = async ({ tableName, pagination, vendorId }) => {
  if (!tableName || pagination.pageIndex === undefined || pagination.pageSize === undefined) {
    throw new Error("Invalid query parameters");
  }

  const response = await axios.post(
    "master/vendor/getData",
    {
      tableName,
      page: pagination.pageIndex + 1,
      limit: pagination.pageSize,
      where: vendorId ? [{ field: "vendorId", operator: "=", value: vendorId }] : [],
    }
  );

  return response?.data?.data?.[0] || { data: [], count: 0 };
};
export const getProducts = async ({ queryKey, signal }) => {
  const [_, pageIndex,pageSize,categoryId] = queryKey;

  const payload = {
    params: {
      page: pageIndex + 1,
      limit: pageSize,
      ...(categoryId && { categoryId }), 
    },
    signal,
  };

  try {
    const response = await axios.get(`master/vendor/getProduct`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveStudentKit = async ({ signal, req }) => {
  const { data } = await axios.post("master/vendor/addSizes", req, { signal });
  return data;
};
export const masterGetDataByid = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/vendor/getData",
    {
      tableName: queryKey[1],
      page: +queryKey[2] + 1,
      limit: queryKey[3],
      where: [{ field: queryKey[4], operator: "=", value: queryKey[5] }],
    },
    { signal }
  );
  return data?.data[0] || [];
};
export const masterSaveVendor = async ({ signal, req, isEditMode }) => {
  if (isEditMode) { 
    const { data } = await axios.patch("master/vendor/updateData/", req , { signal });
    return data.data;
  }
  const { data } = await axios.post("master/vendor/addData/", req , { signal });
  return data.data;
};
export const addProduct = async (productData) => {
  const { data } = await axios.post("/master/vendor/addProduct", productData);
  return data;
};

export const updateProduct = async (productData) => {
  const { data } = await axios.patch("/master/vendor/updateProduct", productData);
  return data;
};
export const fetchInventoryData = async (schoolID, standardID) => {
  let url = `report/vendor/packageinventorytarget?schoolID=${schoolID}`;
  if (standardID) {
    url += `&standardID=${standardID}`;
  }
  const response = await axios.get(url);
  return response.data.data[0] || [];
};
export const invoiceGet = async ({ queryKey, signal }) => {
  const { data } = await axios(`/invoice/vendor/get/${queryKey[1]}`, { signal });
  // console.log(data.data, "data.data");
  return data?.data[0] || {};
};
export const packageAdminList = async ({ queryKey, signal }) => {
  const { data } = await axios("package/admin/list/" + queryKey[1], {
    signal,
  });
  return data.data;
};
export const orderslabel = async orderId => {
  const { data } = await axios.post("orders/vendor/label", orderId);
  return data.data;
};
export const packageAdminConstituents = async id => {
  const { data } = await axios("package/admin/constituents/" + id);
  return data.data;
};
export const cartAdminAdd = async ({ signal, req }) => {
  const { data } = await axios.post("cart/school/add", req, { signal });
  return data;
};

export const masterSaveData = async ({ signal, req, isEditMode }) => {
  if (isEditMode) {
    const { data } = await axios.patch("master/updateData/", req, { signal });
    return data.data;
  }
  const { data } = await axios.post("master/addData/", req, { signal });
  return data.data;
};

export const getProductsWithVariations = async ({ queryKey, signal }) => {
  const [_, pageIndex, pageSize] = queryKey;

  const payload = {
    params: {
      page: pageIndex + 1,
      limit: pageSize,
      variation: 1, // variation=1 for products with variations
    },
    signal,
  };

  try {
    const response = await axios.get(`master/vendor/getProduct`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getProductsWithOutVariations = async ({ queryKey, signal }) => {
  const [_, pageIndex, pageSize] = queryKey;

  const payload = {
    params: {
      page: pageIndex + 1,
      limit: pageSize,
      variation: 0, // 0 for without variation, 1 for with variation
    },
    signal,
  };

  try {
    const response = await axios.get(`master/vendor/getProduct`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addRider = async ({ signal, req }) => {
  const { data } = await axios.post("delivery/addRider", req, { signal });
  return data.data;
};
export const uploadImage = async (type, req) => {
  const { data } = await axios.post(`/upload/vendor/image/${type}`, req, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};
export const getAllRider = async ({ signal }) => {
  const { data } = await axios.get("delivery/getRider", { signal });
  return data.data;
};
export const getAllRiders = async ({ signal }) => {
  const response = await axios.get("delivery/vendor/getVendorRiderDetails", { signal });
  console.log("API Response:", response);
  return response.data; // Return the correct data structure
};

export const allCourierCompany = async ({ signal }) => {
  const { data } = await axios.get("delivery/vendor/getVendorCourierDetails", { signal });
  return data; 
};


export const getAllDeliveryOrder = async ({ signal }) => {
  const { data } = await axios.get("delivery/getOrderDetails", { signal });
  return data.data;
};
export const deliveryAdd = async ({ signal, req }) => {
  const { data } = await axios.post("delivery/add", req, { signal });
  return data;
};
export const schoolList = async ({ signal }) => {
  const { data } = await axios("school/vendor/List", { signal });
  return data;
};
export const packageList = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "package/vendor/List",
    { schoolID: queryKey[1] },
    { signal }
  );
  return data;
};

export const ordersUpdate = async ({ signal, req }) => {
  const { data } = await axios.patch("orders/vendor/update", req, { signal });
  return data;
};
export const masterDataPackage = async req => {
  const { data } = await axios.post("master/vendor/getData", req);
  return data.data;
};
export const ticketsTicketupdate = async ({ signal, req }) => {
  const { data } = await axios.post("tickets/vendor/Ticketupdate", req, {
    signal,
  });
  return data;
};
export const ticketsAdminUpdate = async ({ signal, req }) => {
  const { data } = await axios.post(
    `/tickets/admin/update?ticketID=${req.ticketID}&status=${req.status}`,
    { signal }
  );
  return data;
};
export const masterDeleteData = async ({ signal, req }) => {
  const { data } = await axios.delete( "master/deleteData/", { data: req }, { signal } );
  if (data.status === "Error") {
    throw new Error(data.message || "Failed to delete record");
  }
  return data.data;
};
export const reportSchoolWiseProduct = async (req) => {
  const { schoolID, packageID, productID, initialDate, endDate } = req;

  const baseUrl = "orders/vendor/schoolpendingprod";

  const params = new URLSearchParams();
  if (schoolID) params.append("schoolID", schoolID);
  if (packageID) params.append("packageID", packageID);
  if (productID) params.append("productID", productID);
  if (initialDate) params.append("initialDate", initialDate);
  if (endDate) params.append("endDate", endDate);

  const url = params.toString()
    ? `${baseUrl}?${params.toString()}`
    : baseUrl;

  const response = await axios.get(url);
  return response.data.data;
};

export const reportStudentWiseProduct = async (req) => {
  const { schoolID, packageID, productID, initialDate, endDate } = req;

  const params = new URLSearchParams();

  if (schoolID) params.append("schoolID", schoolID);
  if (packageID) params.append("packageID", packageID);
  if (productID) params.append("productID", productID);
  if (initialDate) params.append("initialDate", initialDate);
  if (endDate) params.append("endDate", endDate);
  
  const url = `report/vendor/pendingProduct?${params.toString()}`;
  
  const response = await axios.get(url);
  return response.data.data;
  };
export const reportNewAndPendingOrder = async req => {
  const { data } = await axios(
    `report/vendor/newAndPendingOrder/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};
export const reportOrderProductReport = async (req) => {
  const { schoolID, initialDate, endDate } = req;

  const params = new URLSearchParams();
  if (schoolID) params.append("schoolID", schoolID);
  if (initialDate) params.append("initialDate", initialDate);
  if (endDate) params.append("endDate", endDate);

  const url = `report/vendor/orderProductReport?${params.toString()}`;
  const { data } = await axios(url);
  return data.data;
};
export const reportNewOrderReport = async req => {
  const { data } = await axios(
    `report/vendor/newOrderReport/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};
export const reportPendingProduct = async req => {
  const { data } = await axios(
    `report/vendor/pendingProduct/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};


export const uploadPromotionOrderProduct = async (payload) => {
  const { data } = await axios.post("upload/vendor/promotionorderproduct", payload);
  return data;
};
